import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "../../assets/css/new-website.css"
import Footer from "../layout/footerLanding";
import Header from "../layout/headerLanding";
import ServiceSectionLeft from "../element/component/ServiceSectionPhysioLeftLanding";
import ServiceSectionRight from "../element/component/ServiceSectionPhysioRightLanding";
import FAQComponent from '../element/component/faq';
import WhyLab from '../element/component/whyLanding';
import ReachToUsForm from "../element/reachToUsFormLanding";
import Popup_Main from "../element/component/Popup_Main";
import VimeoEmbed from "../element/component/vimeoEmbed"; 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

const Physiotherapy = () => {

    const [activeTab, setActiveTab] = useState("jpnagar");
    const [isOpen, setIsOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Change as needed
    slidesToScroll: 1,
    swipe: true,
    touchMove: true,
    draggable: true, // ensures mouse dragging works too
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
         slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
  
    const options = [
      {
        title: "Individual Offline Therapy",
        content: "Personalised sessions focusing on clinical rehabilitation, women’s health, and geriatric care for tailored recovery. "
      },
      {
        title: "Group Offline Therapy",
        content: "Interactive group sessions designed to promote mobility and strength in a supportive environment. "
      },
      {
        title: "Online and At-Home Therapy",
        content: "Convenient individual or group sessions delivered online or at home for flexibility and comfort "
      },
    ];

  const Counter = ({ targetValue, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const startTimestampRef = useRef(null);
  const hasAnimatedRef = useRef(false); // Prevent rerunning animation

  useEffect(() => {
    if (hasAnimatedRef.current) return;

    hasAnimatedRef.current = true; // mark animation as started

    let animationFrame;

    const step = (timestamp) => {
      if (!startTimestampRef.current) startTimestampRef.current = timestamp;
      const progress = timestamp - startTimestampRef.current;
      const progressRatio = Math.min(progress / duration, 1);
      const currentValue = Math.floor(progressRatio * targetValue);

      setCount(currentValue);

      if (progress < duration) {
        animationFrame = requestAnimationFrame(step);
      }
    };

    animationFrame = requestAnimationFrame(step);

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, []); // Run only once on mount

  return <h3>{count}</h3>;
};


  const faqs = [
    {
      question: "What are the benefits of physiotherapy?",
      answer:
        "Benefits of Physiotherapy are: It helps reduce pain, improve mobility, strengthen muscles, and restore functional independence after injury or surgery.",
    },
    {
      question: "Does Bridge Health provide home services for physiotherapy? ",
      answer: "Yes, we offer in-home physiotherapy services, where our certified physiotherapists visit your home to provide personalised care.",
    },
    {
      question: "What types of physiotherapy services does Bridge Health offer in Bangalore?",
      answer: "We offer services such as post-surgical rehab, sports injury recovery, neurological rehab, arthritis management, pain relief treatments, and posture correction.",
    },
    {
      question: "Does Bridge Health offer physiotherapy for elderly patients in Bangalore? ",
      answer: "Yes, we specialise in elderly care, focusing on mobility improvement, pain management, and fall prevention for senior patients.",
    },
    {
      question: "What are the costs of physiotherapy sessions at Bridge Health in Bangalore? ",
      answer: "The cost varies depending on the treatment type and session length. Contact us directly for a personalised quote.",
    },
  ];


  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]); // Refs for multiple sections/cards
  const [hasAnimated, setHasAnimated] = useState([]); // Animation tracking for cards

  // Resize event listener to detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Animation Logic
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const updatedVisibility = sectionRefs.current.map((ref) => {
  //       if (ref) {
  //         const rect = ref.getBoundingClientRect();
  //         const windowHeight =
  //           window.innerHeight || document.documentElement.clientHeight;

  //         // Element becomes visible when its top is within viewport
  //         return rect.top <= windowHeight - 50;
  //       }
  //       return false;
  //     });

  //     setHasAnimated((prev) =>
  //       updatedVisibility.map((visible, index) => prev[index] || visible)
  //     );
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   handleScroll(); // Trigger on mount to check initial visibility
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const cardsData = [
    { title: "Shoulder Pain ", image: "/images/new-website/physiotherapy/neck.webp", desc: "Restore strength and range of motion with personalised shoulder therapy" },
    { title: "Back & Neck Pain ", image: "/images/new-website/physiotherapy/back-neuro.webp", desc: "Relieve stiffness, restore mobility, and improve posture with guided therapy" },
    { title: "Women’s Health ", image: "/images/new-website/physiotherapy/prenatal-care.webp",  desc: "Specialised support for pregnancy recovery, pelvic health, and more" },
    { title: "Ergonomic Exercises ", image: "/images/new-website/physiotherapy/computer-desktop.webp", desc: "Workplace-focused physiotherapy to correct posture and prevent strain injuries" },
    { title: "Post Surgery Rehab ", image: "/images/new-website/physiotherapy/post-surgery.webp", desc: "Supportive recovery programs to help you heal faster and move better after surgery" },
    { title: "Post –Paralysis Rehab", image: "/images/new-website/physiotherapy/technology-1.webp", desc: "Compassionate, structured rehab aimed at regaining function and quality life"  },
    { title: "Neurological Rehab ", image: "/images/new-website/physiotherapy/chiropractic.webp", desc: "Therapy designed for stroke, Parkinson’s, and other neurological conditions"  },
    { title: "Knee Injuries ", image: "/images/new-website/physiotherapy/broken-bone.webp", desc: "Targeted rehab plans to reduce pain, rebuild strength, and regain function"  },
    { title: "Geriatric Mobility ", image: "/images/new-website/physiotherapy/technology.webp", desc: "Gentle, effective physiotherapy to improve balance, strength, and independence" },
    { title: "Sports Injuries ", image: "/images/new-website/physiotherapy/sports-injury.webp", desc: "Get back in the game with expert care for sprains, strains, and joint issues"  },
  
  ];

    const whyData = [
    ];


  const cardsDataRight = [
    { title: "Specialised Expertise", image: "/images/new-website/physiotherapy/physiotherapist.webp", desc: "Certified in treating complex conditions like arthritis, stroke, Parkinson’s, and post-surgery rehabilitation" },
    { title: "Personalized Treatment Plans", image: "/images/new-website/yoga/personalized-treatment.webp", desc: "Tailored care based on your unique needs, diagnosis, and lifestyle" },
    { title: "Holistic Approach", image: "/images/new-website/yoga/comprehensive-holistic-approach.webp", desc: "Addressing your physical, mental, and lifestyle factors for complete well-being"},
    { title: "Home Care Services", image: "/images/new-website/physiotherapy/wide-range-care.webp", desc:"Expert physiotherapists available for in-home sessions, for added comfort and convenience" },
    { title: "Multidisciplinary Support", image: "/images/new-website/physiotherapy/multidisplinary-support.webp", desc:"Access to a network of doctors, neurologists, and specialists for collaborative care"},
    { title: "Transparent Progress Tracking", image: "/images/new-website/physiotherapy/transparent-progress-tracking.webp", desc: "Regular updates and digital tracking to monitor your recovery and improvements"},
    { title: "Certified Professionals", image: "/images/new-website/physiotherapy/certified-professional.webp", desc:"Highly qualified and certified physiotherapists who ensure top-quality care" },
    { title: "Advanced Equipment & Techniques", image: "/images/new-website/physiotherapy/physio-equipments.webp", desc: "Cutting-edge treatments like electrotherapy and robotic rehab for faster recovery" },
      ];

  const styles = {
    headingwoman1: {
        fontSize: "50px",
        color:"#0d0d0d",
        fontWeight: "600",
        lineHeight: "1.2",
        textAlign: "left",
        width: "100%"
      }
  };

  return (
    <>
    <Helmet>
      {/* Google Tag Manager - Head */}
      <script>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-TDX5BRK9');`}
      </script>
    </Helmet>

    {/* Google Tag Manager - Body */}
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-TDX5BRK9"
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="gtm"
      ></iframe>
    </noscript>
    <div>
      <Header/>
      <div className="physio-landing">
        <div className="physio-landing-left">
          <div className="physio-landing-left-inner">
          <h1>
            Personalized Physiotherapy for Fast Relief
          </h1>
          <p className="paragraph-landing-page-sub">
          Care That Comes to You — Because Recovery Should Never Be Inconvenient
          </p>
          </div>
          <div>
            <div className="counter-landing">
              <div class="counterCol">
                Doctor-Supervised Sessions  |  First Consultation FREE  |  Home & Clinic Care
              </div>
            </div>
          </div>
        </div>
        <div className="physio-landing-right">
          <h2>
            Request a Free Consultation Now
          </h2>
          <ReachToUsForm submitted={() => setIsOpen(false)} />
        </div>
      </div>
      
      <section>
            <div style={{marginTop:"50px"}} className="rightstrongcontainerlanding">
            <h2 className="heading1">
            What We
              <span className="highlight1"> Treat </span>
            </h2>
            <p style={{textAlign:"center", width:"100%",  margin: "0 auto"}}>Comprehensive Physiotherapy for Pain, Recovery & Mobility — Expert Care and Backed by doctors for Every Body, Every Age, and Every Condition</p>
                    <div className="physio-service-landing">
                    <ServiceSectionLeft
                            cardsData={cardsData}
                            isMobile={isMobile}
                            highlight="For All Your Health Needs"
                            heading="Personalised Offline & Online Yoga Classes"
                            customClass="WellnessSectionWomen"
                    />
                    {/* <ServiceSectionRight
                        cardsDataRight={cardsDataRight}
                        isMobile={isMobile}
                        highlight="For All Your Health Needs"
                        heading="Personalised Offline & Online Yoga Classes"
                        customClass="WellnessSectionWomen"
                    /> */}
              </div>
              <div className="service-section-button">
                <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Request a Call Back</button>
              </div>
              </div>
      </section>

      <section className="why-choose-section-physio-landing">
          <h2 className="heading1">Why Choose <span className="highlight1">Bridge Health</span> for Physiotherapy</h2>
           <p style={{textAlign:"center", width:"100%",  margin: "0 auto", marginBottom: "20px"}}>Gentle Care, Close to Home — Because Recovery Should Never Feel Distant</p>
                  
          {/* <WhyLab
            whyData={whyData} 
            dynamicText="Radiology" 
            dynamicParagraph="We have some of the best specialists who bring years of experience and offer evidence – based treatment to ensure best care for you" 
          /> */}
          <ServiceSectionRight
                        cardsDataRight={cardsDataRight}
                        isMobile={isMobile}
                        highlight="For All Your Health Needs"
                        heading="Personalised Offline & Online Yoga Classes"
                        customClass="WellnessSectionWomen"
                    />
      </section>

      <section className="why-choose-section-physio-landing">
          <h2 className="heading1">Uncompromised Care <span className="highlight1">For All Ages in Clinic</span>, At Home And in Societies</h2>
                      
          <div className="instagram-video-grid">
           <Slider {...settings}>
          <div>
            <VimeoEmbed videoId="1089025430" />
          </div>
          <div>
            <VimeoEmbed videoId="1089027390" />
          </div>
          <div>
            <VimeoEmbed videoId="1089025526" />
          </div>
        </Slider>
          </div>
          
      </section>

     <section>
        <div>
        <FAQComponent faqs={faqs} />
        </div>
     </section>

     <section className="contact-physio-landing">
          <h2 className="heading1">Request a <span className="highlight1">Call Back</span></h2>
          <div className="callback-landing">
           <ReachToUsForm submitted={() => setIsOpen(false)} />
            </div>
      </section>

    <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
        <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
        <Footer />
    </div>
    </>
  );
};

export default Physiotherapy;
